import { getApi } from 'api';

/**
 * Set the display language of this kiosk's session. The session is resolved from the kiosk token,
 * so a kiosk can only change its own language; the server then uses it for policies and errors.
 */
export const setKioskLanguageRequest = async (kioskToken: string, languageId: number): Promise<void> => {
  await getApi().put('KioskSession/Language', { languageId }, { headers: { Authorization: `Bearer ${kioskToken}` } });
};
